import { useTranslation } from "react-i18next";
import styles from "./LoginSelection.module.css";
import logo from "../../assets/weinig-logo.png";

interface Props {
    microsoftLoginUrl: string;
    salesforceLoginUrl: string;
}

const LoginSelection = ({ microsoftLoginUrl, salesforceLoginUrl }: Props) => {
    const { t } = useTranslation();

    const handleLogin = (url: string, community?: string) => {
        const params = new URLSearchParams();
        params.set("post_login_redirect_uri", window.location.origin + "/");
        if (community) params.set("community", community);
        window.location.href = `${url}?${params.toString()}`;
    };

    return (
        <div className={styles.container}>
            <div className={styles.card}>
                <img src={logo} alt="WEINIG" className={styles.logo} />
                <h1 className={styles.title}>{t("loginSelection.title")}</h1>
                <p className={styles.subtitle}>{t("loginSelection.subtitle")}</p>

                <button
                    className={`${styles.loginButton} ${styles.microsoftButton}`}
                    onClick={() => handleLogin(microsoftLoginUrl)}
                >
                    <svg className={styles.providerIcon} viewBox="0 0 21 21" fill="none">
                        <rect x="1" y="1" width="9" height="9" fill="#F25022" />
                        <rect x="11" y="1" width="9" height="9" fill="#7FBA00" />
                        <rect x="1" y="11" width="9" height="9" fill="#00A4EF" />
                        <rect x="11" y="11" width="9" height="9" fill="#FFB900" />
                    </svg>
                    {t("loginSelection.microsoft")}
                </button>

                <div className={styles.divider}>{t("loginSelection.or")}</div>

                <button
                    className={`${styles.loginButton} ${styles.salesforceButton}`}
                    onClick={() => handleLogin(salesforceLoginUrl)}
                >
                    <svg className={styles.providerIcon} viewBox="0 0 24 24" fill="currentColor">
                        <path d="M10.05 4.65c.9-.93 2.15-1.5 3.53-1.5 1.8 0 3.38.98 4.22 2.43a5.15 5.15 0 0 1 2.2-.5c2.87 0 5.2 2.33 5.2 5.2s-2.33 5.2-5.2 5.2c-.4 0-.78-.05-1.15-.13A4.3 4.3 0 0 1 15 18.1a4.27 4.27 0 0 1-2.65-.92 4.81 4.81 0 0 1-3.33 1.35 4.82 4.82 0 0 1-4.4-2.85 4.15 4.15 0 0 1-1.12.15C1.57 15.83 0 14.26 0 12.33c0-1.5.95-2.78 2.28-3.27a4.06 4.06 0 0 1-.03-.48c0-2.35 1.9-4.25 4.25-4.25 1.2 0 2.28.5 3.05 1.3l.5.02z" />
                    </svg>
                    {t("loginSelection.salesforce")} - Holz-Her
                </button>

                <button
                    className={`${styles.loginButton} ${styles.weinigButton}`}
                    onClick={() => handleLogin(salesforceLoginUrl, "weinig")}
                    style={{ marginTop: "0.75rem" }}
                >
                    <svg className={styles.providerIcon} viewBox="0 0 24 24" fill="currentColor">
                        <path d="M10.05 4.65c.9-.93 2.15-1.5 3.53-1.5 1.8 0 3.38.98 4.22 2.43a5.15 5.15 0 0 1 2.2-.5c2.87 0 5.2 2.33 5.2 5.2s-2.33 5.2-5.2 5.2c-.4 0-.78-.05-1.15-.13A4.3 4.3 0 0 1 15 18.1a4.27 4.27 0 0 1-2.65-.92 4.81 4.81 0 0 1-3.33 1.35 4.82 4.82 0 0 1-4.4-2.85 4.15 4.15 0 0 1-1.12.15C1.57 15.83 0 14.26 0 12.33c0-1.5.95-2.78 2.28-3.27a4.06 4.06 0 0 1-.03-.48c0-2.35 1.9-4.25 4.25-4.25 1.2 0 2.28.5 3.05 1.3l.5.02z" />
                    </svg>
                    {t("loginSelection.salesforce")} - Weinig Group Partner
                </button>
            </div>
        </div>
    );
};

export default LoginSelection;
